export type ISaveFile = {
  save: (fileName: string, content: any) => void;
};

export const files: ISaveFile = {
  save(fileName, content) {
    const dataStr =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(toUnminifiedJSON(content));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute(
      'download',
      `${fileName}.${Date.now()}.json`
    );
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }
};

const toUnminifiedJSON = (content: string) => JSON.stringify(content, null, 4);
